import { render, staticRenderFns } from "./BoxImage.vue?vue&type=template&id=c4d3feb4&scoped=true&"
import script from "./BoxImage.vue?vue&type=script&lang=js&"
export * from "./BoxImage.vue?vue&type=script&lang=js&"
import style0 from "./BoxImage.vue?vue&type=style&index=0&id=c4d3feb4&scoped=true&lang=css&"
import style1 from "./BoxImage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d3feb4",
  null
  
)

export default component.exports